import React from "react";
import styles from './LoadingOverlay.module.scss';
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

const LoadingOverlay = () => {
  return (
    <div className={styles.overlay}>
      <LoadingSpinner />
    </div>
  );
};

export default LoadingOverlay;